import type { Block } from "@aswin.dev/types";
import {
  isSection,
  isTitle,
  isParagraph,
  isImage,
  isInput,
  isButton,
  isDivider,
  isSpacer,
  isHtml,
  isSocialIcons,
  isMenu,
  isTable,
  isVideo,
  isCustomBlock,
} from "@aswin.dev/types";
import type { RenderContext } from "../render-context";
import { renderTitle } from "./title";
import { renderParagraph } from "./paragraph";
import { renderImage } from "./image";
import { renderInput } from "./input";
import { renderButton } from "./button";
import { renderDivider } from "./divider";
import { renderSpacer } from "./spacer";
import { renderHtml } from "./html";
import { renderSocialIcons } from "./social";
import { renderMenu } from "./menu";
import { renderTable } from "./table";
import { renderCustom } from "./custom";
import { renderSection } from "./section";
import { renderVideo } from "./video";

/**
 * Render a single block to MJML markup.
 * Dispatches to the appropriate block-type renderer.
 */
export function renderBlock(block: Block, context: RenderContext): string {
  if (isSection(block)) {
    return renderSection(block, context, renderBlock);
  }

  if (isTitle(block)) {
    return renderTitle(block, context);
  }

  if (isParagraph(block)) {
    return renderParagraph(block, context);
  }

  if (isImage(block)) {
    return renderImage(block, context);
  }

  if (isInput(block)) {
    return renderInput(block, context);
  }

  if (isButton(block)) {
    return renderButton(block, context);
  }

  if (isDivider(block)) {
    return renderDivider(block, context);
  }

  if (isSpacer(block)) {
    return renderSpacer(block, context);
  }

  if (isHtml(block)) {
    return renderHtml(block, context);
  }

  if (isSocialIcons(block)) {
    return renderSocialIcons(block, context);
  }

  if (isMenu(block)) {
    return renderMenu(block, context);
  }

  if (isTable(block)) {
    return renderTable(block, context);
  }

  if (isVideo(block)) {
    return renderVideo(block, context);
  }

  if (isCustomBlock(block)) {
    return renderCustom(block, context);
  }

  // Countdown blocks are rendered by the Templatical Cloud backend.
  // In OSS mode they return empty — use initCloud() for full countdown support.
  return "";
}
